<template lang="pug">
  div.hotline
    span HOTLINE
    | {{ phone }}
</template>
<script>
  export default {
    name: 'Hotline',
    props: ['phone'],
  }
</script>



// WEBPACK FOOTER //
// src/components/Hotline.vue